//
// Common functions for google maps
//

// is maps loaded?
let mapsLoaded = false;

/**
 * Callback for google maps load
 */
window.jbGoogleMapsLoaded = function () {
  mapsLoaded = true;
  // Make sure we have the dev icons if we're in dev mode
  localizeIcons();
  $(window).trigger('googleMapsLoaded');
};

/**
 * Makes sure maps are loaded before running
 */
export function googleMapsInit(callback) {
  if (typeof window.google !== 'undefined' && window.google.maps) {
    callback();
    return;
  }

  if (!mapsLoaded) {
    const script = document.createElement('script');
    script.src =
      '//maps.googleapis.com/maps/api/js?client=gme-jbhifi&sensor=true&libraries=places,geometry&callback=jbGoogleMapsLoaded';
    document.body.appendChild(script);
    mapsLoaded = true;
  }

  // Trigger callback on load
  $(window).on('googleMapsLoaded', () => {
    callback();
  });
}

// Deal with local files for gmaps
let hasLocalizeIconRun = false;
function localizeIcons() {
  if (!window.Jbhifi.mapIcons || hasLocalizeIconRun) {
    return;
  }
  // if (!window.Jbhifi.isProd) {
  //   Object.keys(window.Jbhifi.mapIcons).forEach(icon => {
  //     window.Jbhifi.mapIcons[icon] = `https://localhost:8082/${icon}`;
  //   });
  // }
  hasLocalizeIconRun = true;
}

/**
 * Gets marker image for different
 */
export function markerImage(icon) {
  switch (icon) {
    case 'state':
      return window.Jbhifi.mapIcons['pin-state.png'];
    case 'cluster':
      return window.Jbhifi.mapIcons['pin-large.png'];
    case 'transparent':
      return window.Jbhifi.mapIcons['pin-transparent.gif'];
    case 'single':
    default:
      return window.Jbhifi.mapIcons['pin-single.png'];
  }
}

/**
 * Default styles for markers
 */
export function markerStyle(marker = {}, icon = 'single') {
  marker.icon = markerImage(icon);
  return marker;
}

/**
 * Default styles for popups
 */
export function popupStyle(popup = {}) {
  return $.extend(
    {
      minWidth: 350,
      minHeight: 'auto',
      shadowStyle: 0,
      padding: 20,
      backgroundColor: '#fff',
      borderRadius: 0,
      arrowSize: 0,
      arrowColor: '#fff',
      borderWidth: 1,
      borderColor: '#000',
      disableAutoPan: false,
      hideCloseButton: false,
      enableEventPropagation: true,
      arrowPosition: 50,
      arrowStyle: 0,
    },
    popup
  );
}

/**
 * Default options for map
 */
export function mapOptions(options = {}) {
  return $.extend(
    {
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: false,
      disableDoubleClickZoom: false,
      draggable: true,
      scrollwheel: true,
      panControl: true,
    },
    options
  );
}

/**
 * Enables zoom controls
 */
export function enableZoomControls(map) {
  map.setOptions(mapOptions());
}

/**
 * Zooms to a marker
 */
export function zoomToMarker(map, marker, zoom = 17) {
  map.setZoom(zoom);
  map.panTo(marker.position);
}

/**
 * Gets bounds from marker set
 */
export function setBoundsFromMarkers(map, markers) {
  const bounds = new google.maps.LatLngBounds();
  markers.forEach(marker => bounds.extend(marker.getPosition()));
  return bounds;
}

export function openGoogleMaps(storeAddres) {
  const baseURI = 'https://maps.google.com/maps?t=m&z=15&q=';
  const address = `JB Hi-Fi ${storeAddres.Line1}, ${storeAddres.Line2}, ${storeAddres.Line3}, ${storeAddres.Suburb}, ${storeAddres.State}, ${storeAddres.Postcode}`;
  window.open(`${baseURI}${encodeURIComponent(address)}`);
}
